import {
  ChooseDepositAccountPage,
  LoadingPage,
} from '@resurs-internal/deposits-app-components';
import { isAuthenticated } from 'helpers/authSessionUtils';
import { useContext } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router';

import { CountryContext } from '@/contexts';
import { getSectionCount, sendGTMProductCategory } from '@/helpers';
import { useCampaignCode, useProducts } from '@/hooks';
import { authenticateUser } from '@/services';

export const ChooseDepositAccountSection = () => {
  const { country } = useContext(CountryContext);
  const navigate = useNavigate();
  const { productCode } = useParams();
  const [searchParams] = useSearchParams();
  const unavailableProductCode =
    searchParams.get('unavailableProductCode') || undefined;
  const { appendCampaignCode, createParamsWithCampaignCode } =
    useCampaignCode();
  const { isLoading, productFromCode, products } = useProducts(country);

  const validProductCode =
    productCode && productFromCode?.(productCode) ? productCode : undefined;

  const navigateBack = () => {
    if (productCode)
      navigate(
        appendCampaignCode(`/product/${encodeURIComponent(productCode)}`),
      );
    else navigate(appendCampaignCode('/'));
  };

  const handleAuthenticateUser = (productCode: string) => {
    const authPath = appendCampaignCode('/application');

    authenticateUser(authPath, productCode, country);
  };

  const navigateForward = (productCode: string) => {
    const params = createParamsWithCampaignCode({ state: productCode });

    navigate(`../application?${params.toString()}`);
  };

  const navigateToFixedTerm = (productCode: string) => {
    navigate(
      appendCampaignCode(
        `/choose-fixed-term/${encodeURIComponent(productCode)}`,
      ),
    );
  };

  if (isLoading) return <LoadingPage country={country} />;

  const handleGTMProductCategory = (productVariant: string) => {
    sendGTMProductCategory(productVariant, country);
  };

  return (
    <ChooseDepositAccountPage
      authenticateUser={handleAuthenticateUser}
      country={country}
      disabledProducts={unavailableProductCode ? [unavailableProductCode] : []}
      isAuthenticated={isAuthenticated()}
      isLoading={isLoading}
      navigateBack={navigateBack}
      navigateForward={navigateForward}
      navigateToFixedTerm={navigateToFixedTerm}
      preselectedProductCode={validProductCode}
      products={products}
      sendGTMProductCategory={handleGTMProductCategory}
      totalSections={getSectionCount(country)}
    />
  );
};
